// extracted by mini-css-extract-plugin
export var scrollArea = "_r1-0";